module.exports = __webpack_public_path__ + "media/images/cleaning/card-desktop-5f6cdadb0f749488948140172b8ced9c.jpg";